/**
 * Returns true only when the backend explicitly confirmed WTB retailers exist.
 * showCC must be set to true by WTBService
 * @param {Object|null} ctaInfo
 * @returns {boolean}
 */
export const isWtbAvailable = (ctaInfo) => ctaInfo?.showCC === true

/**
 * Resolves the manufacturer IDs to use for WTB Commerce Connector calls.
 * Returns null for scenarios where IDs are determined dynamically at runtime
 * (e.g. parent with visible SKUs narrowed by user selection).
 *
 * Scenarios covered:
 *  1. Non-parent (SKU) with wtbMmmIds          → wtbMmmIds
 *  2. Non-parent (SKU) without wtbMmmIds       → [stockNumber, originalMmmid]
 *  3. Parent + pdpSelectorOverride + wtbMmmIds → wtbMmmIds
 *  4. Parent + no selector table + wtbMmmIds   → wtbMmmIds
 *
 * @param {{ isParent: boolean, moreOptions: Object, ctaInfo: Object, productDetails: Object }} productData
 * @returns {string[]|null}
 */
export const resolveWtbMmmIds = ({ isParent, moreOptions, ctaInfo, productDetails }) => {
    if (!isParent && moreOptions?.wtbMmmIds?.length > 0) {
        return moreOptions.wtbMmmIds
    }
    if (!isParent && !moreOptions?.wtbMmmIds) {
        const { stockNumber, originalMmmid } = productDetails || {}
        if (stockNumber && originalMmmid) return [stockNumber, originalMmmid]
    }
    if (isParent && ctaInfo?.pdpSelectorOverride && moreOptions?.wtbMmmIds?.length > 0) {
        return moreOptions.wtbMmmIds
    }
    if (isParent && !moreOptions?.options?.length && moreOptions?.wtbMmmIds?.length > 0) {
        return moreOptions.wtbMmmIds
    }
    return null
}
